import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logout as logoutService } from '../../api'
import { useReduxSelector } from '../../hooks'
import { FETCH_AUTH_FAILURE } from '../../store/auth/types'

const ls = require('local-storage')

export const LogoutPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { auth } = useReduxSelector((state) => state.auth)

  const { REACT_APP_PORTAL_URL: PORTAL } = process.env

  useEffect(() => {
    if (auth) {
      logoutService().then(() => {
        ls.remove('token_private')
        dispatch({
          type: FETCH_AUTH_FAILURE,
          payload: {},
        })
        window.location.href = `${PORTAL}`
      })
    } else {
      window.location.href = `${PORTAL}`
    }
  }, [auth])

  return <></>
}
